export default {
    path: 'user',
    component: () => import('../Member.vue'),
    children: [
        {
            path: '',
            name: 'Danh sách thành viên',
            component: () => import('../table/Table.vue')
        },
        {
            path: 'cu',
            name: 'Tạo thành viên mới',
            component: () => import('../cu/CU.vue'),
        },
        {
            path: 'cu/:id',
            name: 'Chỉnh sửa thông tin thành viên',
            component: () => import('../cu/CU.vue'),
        },
    ]
};